import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React from "react";
import { dialogStyles } from "../../../../../Constants/dialogStyles";
import { inputStyles } from "../../../../../Constants/inputStyles";
import {
  primaryButtonStyles,
  textButtonStyles,
} from "../../../../../Constants/buttonStyles";

const EditSelectedUserDialog = ({
  openEditDialog,
  handleEditClose,
  editingUser,
  handleEditChange,
  isAlphabetic,
  user,
  isUserDataChanged,
  saveUpdatedUser,
}) => {
  return (
    <Dialog
      open={openEditDialog}
      // onClose={handleEditClose}
      PaperProps={{ sx: dialogStyles.dialogRoot }}
      BackdropProps={{ invisible: true }}
      disableEscapeKeyDown
      fullWidth
    >
      <DialogTitle sx={dialogStyles.dialogTitle}>Edit User </DialogTitle>
      <DialogContent sx={dialogStyles.dialogContent}>
        <TextField
          autoFocus
          margin="dense"
          name="first_name"
          placeholder="First Name"
          type="text"
          fullWidth
          variant="outlined"
          value={editingUser.first_name}
          onChange={handleEditChange}
          sx={{ ...inputStyles.textField, mb: 1 }}
          error={
            editingUser.first_name && !isAlphabetic(editingUser.first_name)
          }
          helperText={
            editingUser.first_name && !isAlphabetic(editingUser.first_name)
              ? "First name should contain only letters"
              : ""
          }
        />
        <TextField
          margin="dense"
          name="last_name"
          placeholder="Last Name"
          type="text"
          fullWidth
          variant="outlined"
          value={editingUser.last_name}
          onChange={handleEditChange}
          sx={inputStyles.textField}
          error={editingUser.last_name && !isAlphabetic(editingUser.last_name)}
          helperText={
            editingUser.last_name && !isAlphabetic(editingUser.last_name)
              ? "Last name should contain only letters"
              : ""
          }
        />

        {!(
          user?.user?.privilege === "admin" &&
          editingUser?.privilege === "owner"
        ) && (
          <>
            <Select
              value={editingUser.privilege}
              margin="dense"
              name="privilege"
              onChange={handleEditChange}
              fullWidth
              variant="outlined"
              displayEmpty
              sx={{
                ...inputStyles.select,
                mb: 1,
              }}
            >
              <MenuItem value="" disabled>
                Privilege
              </MenuItem>
              <MenuItem value="owner">Owner</MenuItem>
              <MenuItem value="admin">Admin</MenuItem>
              <MenuItem value="member">Member</MenuItem>
            </Select>
            <Select
              value={editingUser.permissions}
              margin="dense"
              name="permissions"
              onChange={handleEditChange}
              fullWidth
              variant="outlined"
              displayEmpty
              sx={{
                ...inputStyles.select,
                mt: 1,
              }}
            >
              <MenuItem value="" disabled>
                Permissions
              </MenuItem>
              <MenuItem value="1">Public</MenuItem>
              <MenuItem value="2">Confidential</MenuItem>
              <MenuItem value="3">Secret</MenuItem>
            </Select>
          </>
        )}
      </DialogContent>
      <DialogActions sx={dialogStyles.dialogActions}>
        <Button onClick={handleEditClose} sx={textButtonStyles}>
          Cancel
        </Button>
        <Button
          onClick={saveUpdatedUser}
          sx={primaryButtonStyles}
          disabled={!isUserDataChanged()}
        >
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditSelectedUserDialog;
